import React, { useState } from 'react';

interface LogoProps {
  className?: string;
  size?: number;
}

export const Logo: React.FC<LogoProps> = ({ className = '', size = 40 }) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  // Fallback SVG logo if image fails to load
  if (imageError) {
    return (
      <div 
        className={`flex items-center justify-center bg-[#0055AA] text-white font-bold rounded ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.3 }}
      >
        BP
      </div>
    );
  }

  return (
    <img
      src="/images/beyondpages_logo.png"
      alt="BeyondPages Logo"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      onError={handleImageError}
    />
  );
};

export const LogoWithText: React.FC<{ className?: string; size?: number }> = ({ 
  className = '', 
  size = 40 
}) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Logo size={size} />
      <span className="font-bold text-xl">BeyondPages</span>
    </div>
  );
}; 